export default "__VITE_ASSET__ivGM8G9w__"